/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 1/25/15
 * Time: 6:16 PM
 * To change this template use File | Settings | File Templates.
 */
    //positionsUtility.js


define(function (require) {
    "use strict";

    var positionsUtility=(function() {
        var _POSITION_X = {
            LEFT: "left",
            RIGHT: "right"
        };
        var _POSITION_Y = {
            TOP: "top",
            BOTTOM: "bottom"
        };
        var _DEFAULT_OFFSET = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };

        function _getOffset(selector, positionX, positionY) {
            if (!selector) {
                return;
            }
            var positionObj = {};
            positionX = positionX || _POSITION_X.LEFT;
            positionY = positionY || _POSITION_Y.TOP;

            var element = $(selector);
            var offset = element.offset() || _DEFAULT_OFFSET;
            if (positionX === _POSITION_X.LEFT) {
                positionObj.left = offset.left + "px";
            } else {
                positionObj.right = (($(window).width() + $(window).scrollLeft()) - (offset.left + element.outerWidth(true))) + "px";
            }
            if(positionY === _POSITION_Y.TOP){
                positionObj.top= offset.top + "px";
            }else{
                positionObj.bottom= (($(window).height() + $(window).scrollTop()) - (offset.top + element.outerHeight(true))) + "px";
            }
            return positionObj;
        }

        return {
            getOffset: _getOffset,
            POSITION_X: _POSITION_X,
            POSITION_Y: _POSITION_Y
        };
    })();
      return positionsUtility;
});
